import { useEffect, useState } from 'react'
import { apiErrorText } from '@/lib/api-error'
import { cardTitle, formCardSm } from '@/lib/form-styles'
import { useTerminology } from '@/lib/useTerminology'
import { fetchProjectDeclarations, oeffneProjektdatei, type ProjectDeclarationRow } from '../api/project-tech.api'
import { alsZeitpunkt } from '../project-labels'

/** AP-35 Detailblatt 6 4.4 — Karte „Leistungserklärungen" im Reiter Dokumente. */
export function ProjectDeclarationsCard({ projectId }: { projectId: string }) {
  const terms = useTerminology()
  const [zeilen, setZeilen] = useState<ProjectDeclarationRow[] | null>(null)
  const [fehler, setFehler] = useState<string | null>(null)

  useEffect(() => {
    fetchProjectDeclarations(projectId)
      .then(setZeilen)
      .catch((e) => setFehler(apiErrorText(e, 'Die Leistungserklärungen konnten nicht geladen werden.')))
  }, [projectId])

  if (!zeilen?.length && !fehler) return null
  const oeffne = (id: string, name: string) =>
    oeffneProjektdatei(id, name).catch((e) => setFehler(apiErrorText(e, 'Die Datei lässt sich nicht öffnen.')))

  return (
    <div className={formCardSm}>
      <h3 className={cardTitle}>Leistungserklärungen</h3>
      {fehler && <p className="mt-2 text-sm text-destructive">{fehler}</p>}
      <table className="mt-2 w-full text-sm">
        <thead className="text-xs text-muted-foreground">
          <tr>
            <th className="px-2 py-1 text-left">Nummer</th>
            <th className="px-2 py-1 text-left">{terms.position}</th>
            <th className="px-2 py-1 text-left">Version</th>
            <th className="px-2 py-1 text-left">Datum</th>
            <th className="px-2 py-1 text-left">Status</th>
            <th className="px-2 py-1 text-left">Dateien</th>
          </tr>
        </thead>
        <tbody>
          {(zeilen ?? []).map((z) => (
            <tr key={z.id} className="border-t border-border">
              <td className="px-2 py-1 font-medium">{z.number}</td>
              <td className="px-2 py-1">
                {z.position.number} {z.position.name}
              </td>
              <td className="px-2 py-1">{z.version}</td>
              <td className="px-2 py-1">{alsZeitpunkt(z.issuedAt)}</td>
              <td className="px-2 py-1">{z.status === 'ISSUED' ? 'gültig' : 'zurückgezogen'}</td>
              <td className="px-2 py-1">
                <span className="flex gap-2">
                  {z.pdfFileId && (
                    <button type="button" className="text-primary hover:underline" onClick={() => void oeffne(z.pdfFileId!, `${z.number}.pdf`)}>
                      PDF
                    </button>
                  )}
                  {z.ceLabelFileId && (
                    <button type="button" className="text-primary hover:underline" onClick={() => void oeffne(z.ceLabelFileId!, `${z.number}-CE.pdf`)}>
                      CE-Etikett
                    </button>
                  )}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
